enum TrackState {
  /** Track of stream doesn't exist or ended */
  Off      = 'off',
  /** Track was muted by the browser or OS */
  Muted    = 'muted',
  /** Track was disabled by user by setting `track.enabled` to `false` */
  Disabled = 'disabled',
  /** Track is playing */
  Active   = 'active',
}

export default TrackState;

export function getTrackState(track?: MediaStreamTrack): TrackState {
  if (!track) { return TrackState.Off; }
  if (track.readyState === 'ended') { return TrackState.Off; }
  // If it's enabled but muted, it means it's muted outside of our
  // control, on the OS level. If it's disabled and muted, it was muted
  // because there was no consumer for the data after disabling, like
  // `<video>` element or a `RTCPeerConnection`. If it's enabled back
  // again and a consumer appears, it'll become unmuted. This behaviour
  // is only happening in Chrome at this point.
  if (track.enabled && track.muted) { return TrackState.Muted; }
  if (!track.enabled) { return TrackState.Disabled; }
  return TrackState.Active;
}

export function getStreamTrackState(stream?: MediaStream): TrackState {
  return getTrackState(stream && stream.getTracks()[0]);
}

/**
 * Peers don't care if the track is muted or disabled so show both cases as `muted`.
 */
export function trackStateForPeer(state: TrackState) {
  // For peers disabled and muted have the same outcome
  if (state === TrackState.Disabled) { return TrackState.Muted; }
  return state;
}
